/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  client_pb: {
    options: {
      go_package: "./client_pb"
    },
    nested: {
      GetChatHistoryRequest: {
        fields: {
          messageIndex: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      GetChatHistoryResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          messages: {
            rule: "repeated",
            type: "ChatMessage",
            id: 4
          }
        },
        nested: {
          ChatMessage: {
            fields: {
              role: {
                type: "RoleType",
                id: 1
              },
              content: {
                type: "string",
                id: 2
              },
              index: {
                type: "int32",
                id: 3
              },
              timestamp: {
                type: "int64",
                id: 4
              },
              messageId: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      RoleType: {
        values: {
          ROLE_TYPE_DEFAULT: 0,
          ROLE_TYPE_USER: 1,
          ROLE_TYPE_ASSISTANT: 2
        }
      },
      GetUserPermissionRequest: {
        fields: {}
      },
      GetUserPermissionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          permission: {
            type: "bool",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          }
        }
      },
      VehicleDamageCheckRequest: {
        fields: {
          image: {
            type: "string",
            id: 1
          }
        }
      },
      VehicleDamageCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          id: {
            type: "int32",
            id: 3
          },
          results: {
            rule: "repeated",
            type: "VehicleDamageResult",
            id: 5
          }
        },
        nested: {
          VehicleDamageResult: {
            fields: {
              damageLevel: {
                type: "string",
                id: 1
              },
              partName: {
                type: "string",
                id: 2
              },
              source: {
                type: "string",
                id: 3
              },
              damagePosition: {
                type: "DamagePosition",
                id: 4
              },
              partPosition: {
                type: "DamagePosition",
                id: 5
              }
            }
          },
          DamagePosition: {
            fields: {
              height: {
                type: "int32",
                id: 1
              },
              wight: {
                type: "int32",
                id: 2
              },
              xmin: {
                type: "int32",
                id: 3
              },
              ymin: {
                type: "int32",
                id: 4
              }
            }
          }
        }
      }
    }
  }
});

export { $root as default };
